export const refreshStoredCanvasList = new Event('odi_canvas_refresh');
export const resetCanvas = 'resetcanvas';
